import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from './../../../Auth/AuthContext';
import { BotonVerAtencionesPersona } from '../../Utils/BotonVerAtencionesPersona';
import SeccionPageHeader from './../../Utils/SeccionPageHeader';
import CargandoSpinner from './../../Utils/CargandoSpinner';
import { useForm, Controller } from 'react-hook-form';
import CustomInput from '../../Utils/CustomInput';
import { Container, ButtonGroup } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { FaCalendar, FaList, FaSearch } from 'react-icons/fa';

export default function DiagnosticoRetornoXIntegrante(){
    const {token} = useAuth();
    const fecha = new Date();
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const { control, handleSubmit, watch, formState: { errors }} = useForm({
            defaultValues: { 
                FechaInicial: fecha, 
                FechaFinal: fecha
            }
        });
    const [datosRetorno, setDatosRetorno] = useState([]);
    const [swalProps, setSwalProps] = useState();
    
    const fetchData = async (fechaInicio, fechaFin) => {
        const url = `/caracterizacion/diagnosticos/listardatoretornoxintegrante?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosRetorno(result);
        } catch (error) {
            if (error.response && error.response.status === 409) {
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: error.response.data.message || 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            } else {
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la informaci&oacute;n de personas.',
                    showConfirmButton: true,
                });
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    async function onSubmit(data) {
        await fetchData(
            data.FechaInicial.toLocaleDateString('en-CA'), 
            data.FechaFinal.toLocaleDateString('en-CA')
        );
    }
    const [filters, setFilters] = useState({
        tip_tipoidentificacion: '',
    });
    // Filtrado de datos
    const filteredData = datosRetorno.filter(row =>
        (!filters.tip_tipoidentificacion || row.tip_tipoidentificacion === filters.tip_tipoidentificacion) 
    );

    // Paginación
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    
    function verAtencionPersonas (row, verAtencionesPersona){
            return <BotonVerAtencionesPersona verAtencionesPersona={verAtencionesPersona} id={row.per_idpersona} row={row} />
        }
    const columns = [
        {
            name: 'Acciones',
            cell: row => verAtencionPersonas(row, verAtencionesPersona),
            ignoreRowClick: true,
            width: '3%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'1%' },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width:'2%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '3%'},
        { name: 'Fecha entrevista', selector: row => row.ret_fechaentrevista, sortable: true, width: '2%'},
        { name: 'Fecha visita', selector: row => row.ret_fechavisitadomiciliaria, sortable: true, width: '2%' },
        { name: 'Diligenciar el tipo de apoyo que se solicita', selector: row => row.tip_tipoapoyo, sortable: true, width: '2%' },
        { name: 'Motivos planteados por el grupo para retorno', selector: row => row.tipo_motivo, sortable: true, width: '2%' },
        { name: '¿Se entrega carta de voluntariedad?', selector: row => row.ret_redesvoluntariedad, sortable: true, width: '2%' },
        { name: 'En caso de no entregar carta de voluntariedad expresar por qué', selector: row => row.razon_no_voluntariedad, sortable: true, width: '2%' },
        { name: 'No. de personas del núcleo familiar que serían retornadas o reubicadas', selector: row => row.ret_nropersonas, sortable: true, width: '2%' },
        { name: 'Departamento', selector: row => row.dep_departamento, sortable: true, width: '2%' },
        { name: 'Municipio', selector: row => row.mun_municipio, sortable: true, width: '10%' },
        { name: 'Comuna o corregimiento para donde desea retornar o reubicarse la familia', selector: row => row.ret_corregimientopeticion, sortable: true, width: '10%' },
        { name: 'Barrio o vereda para donde desea retornar o reubicarse', selector: row => row.ret_veredabarriopeticion, sortable: true, width: '10%' },
        { name: 'Dirección', selector: row => row.ret_direccionpeticion, sortable: true, width: '10%' },
        { name: 'Teléfono', selector: row => row.ret_telefonopeticion, sortable: true, width: '10%' },
        { name: 'Tipo de entorno del lugar en donde desea retornar o reubicarse la familia', selector: row => row.tip_tipoentorno, sortable: true, width: '10%' },
        { name: '¿Algún miembro del grupo familiar es propietario(a) del bien donde la familia desea retornar o reubicarse?', selector: row => row.ret_viviendaintegrante, sortable: true, width: '10%' },
        { name: 'Tipo de bien inmueble en donde la familia desea retornar o reubicarse', selector: row => row.tip_tipobien, sortable: true, width: '10%' },
        { name: '¿Se tiene documentación que acredite la propiedad del bien inmueble?', selector: row => row.ret_documentacionvivienda, sortable: true, width: '10%' },
        { name: '¿Realizó proceso de protección del bien abandonado?', selector: row => row.ret_protegiobien, sortable: true, width: '10%' },
        { name: '¿Posee resolución de la protección del bien?', selector: row => row.ret_resolucionproteccion, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentra el techo de la vivienda', selector: row => row.EstadoTecho, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentran los pisos de la vivienda', selector: row => row.EstadoPisos, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentran los baños de la vivienda', selector: row => row.EstadoBanos, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentran las paredes de la vivienda', selector: row => row.EstadoParedes, sortable: true, width: '10%' },
        { name: 'Estado en que se encuentra la cocina de la vivienda', selector: row => row.EstadoCocina, sortable: true, width: '10%' },
        { name: 'La vivienda cuenta con servicio de alcantarillado', selector: row => row.ret_servicioalcantarillado, sortable: true, width: '10%' },
        { name: 'La vivienda cuenta con pozo séptico', selector: row => row.ret_serviciopozoseptico, sortable: true, width: '10%' },
        { name: 'La vivienda cuenta con servicio de acueducto', selector: row => row.ret_servicioacueducto, sortable: true, width: '10%' },
        { name: 'La vivienda cuenta con servicio de energía', selector: row => row.ret_servicioenergia, sortable: true, width: '10%' },
        { name: 'Educación', selector: row => row.ret_educacion, sortable: true, width: '10%' },
        { name: 'Seguridad', selector: row => row.ret_redesconceptoseguridad, sortable: true, width: '10%' },
        { name: '¿Se construyó plan de vida para el proceso de retorno o reubicación?', selector: row => row.ret_redesplanvida, sortable: true, width: '10%' },
        { name: 'Explotación agrícola', selector: row => row.tipo_explotacion, sortable: true, width: '10%' },
        { name: 'Especies que le gustaría trabajar en su predio', selector: row => row.tipo_especies, sortable: true, width: '10%' },
        { name: 'Nro. de personas a transportar', selector: row => row.ret_redestransportepersonasnro, sortable: true, width: '10%' },
        { name: 'Costo aproximado transporte de personas', selector: row => row.ret_redestransportepersonascosto, sortable: true, width: '10%' },
        { name: 'Costo acarreo de enceres', selector: row => row.ret_redesacarreocosto, sortable: true, width: '10%' },
        { name: 'Objetos por llevar', selector: row => row.tipo_objetos, sortable: true, width: '10%' },
        { name: 'Id Cabeza', selector: row => row.ret_idcabezafamilia, sortable: true, width: '2%' },
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    
    async function exportarCSV(fechaInicio, fechaFin) {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatoretornoxintegrante?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&csv=true`;
        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_retorno.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }

    async function exportaExcel() {
        import('xlsx').then(XLSX => {
            // Define column titles in desired order
            const headers = [
                'Id',
                'Identificación',
                'Nombre',
                'Fecha entrevista',
                'Fecha visita',
                'Diligenciar el tipo de apoyo que se solicita',
                'Motivos planteados por el grupo para retorno',
                '¿Se entrega carta de voluntariedad?',
                'En caso de no entregar carta de voluntariedad expresar por qué',
                'No. de personas del núcleo familiar que serían retornadas o reubicadas',
                'Departamento',
                'Municipio',
                'Comuna o corregimiento para donde desea retornar o reubicarse la familia',
                'Barrio o vereda para donde desea retornar o reubicarse',
                'Dirección',
                'Teléfono',
                'Tipo de entorno del lugar en donde desea retornar o reubicarse la familia',
                '¿Algún miembro del grupo familiar es propietario(a) del bien donde la familia desea retornar o reubicarse?',
                'Tipo de bien inmueble en donde la familia desea retornar o reubicarse',
                '¿Se tiene documentación que acredite la propiedad del bien inmueble?',
                '¿Realizó proceso de protección del bien abandonado?',
                '¿Posee resolución de la protección del bien?',
                'Estado en que se encuentra el techo de la vivienda',
                'Estado en que se encuentran los pisos de la vivienda',
                'Estado en que se encuentran los baños de la vivienda',
                'Estado en que se encuentran las paredes de la vivienda',
                'Estado en que se encuentra la cocina de la vivienda',
                'La vivienda cuenta con servicio de alcantarillado',
                'La vivienda cuenta con pozo séptico',
                'La vivienda cuenta con servicio de acueducto',
                'La vivienda cuenta con servicio de energía',
                'Educación',
                'Seguridad',
                '¿Se construyó plan de vida para el proceso de retorno o reubicación?',
                'Explotación agrícola',
                'Especies que le gustaría trabajar en su predio',
                'Nro. de personas a transportar',
                'Costo aproximado transporte de personas',
                'Costo acarreo de enceres',
                'Objetos por llevar',
                'Id Cabeza'
                ];

            // Map data to match header order
            const wsData = filteredData.map(row => {
                return [
                    row.id,
                    row.per_idpersona,
                    row.nombre,
                    row.ret_fechaentrevista,
                    row.ret_fechavisitadomiciliaria,
                    row.tip_tipoapoyo,
                    row.tipo_motivo,
                    row.ret_redesvoluntariedad,
                    row.razon_no_voluntariedad,
                    row.ret_nropersonas,
                    row.dep_departamento,
                    row.mun_municipio,
                    row.ret_corregimientopeticion,
                    row.ret_veredabarriopeticion,
                    row.ret_direccionpeticion,
                    row.ret_telefonopeticion,
                    row.tip_tipoentorno,
                    row.ret_viviendaintegrante,
                    row.tip_tipobien,
                    row.ret_documentacionvivienda,
                    row.ret_protegiobien,
                    row.ret_resolucionproteccion,
                    row.EstadoTecho,
                    row.EstadoPisos,
                    row.EstadoBanos,
                    row.EstadoParedes,
                    row.EstadoCocina,
                    row.ret_servicioalcantarillado,
                    row.ret_serviciopozoseptico,
                    row.ret_servicioacueducto,
                    row.ret_servicioenergia,
                    row.ret_educacion,
                    row.ret_redesconceptoseguridad,
                    row.ret_redesplanvida,
                    row.tipo_explotacion,
                    row.tipo_especies,
                    row.ret_redestransportepersonasnro,
                    row.ret_redestransportepersonascosto,
                    row.ret_redesacarreocosto,
                    row.tipo_objetos,
                    row.ret_idcabezafamilia
                ];
            });

            // Add header row
            wsData.unshift(headers);

            // Create worksheet from array of arrays
            const ws = XLSX.utils.aoa_to_sheet(wsData);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Informeretorno');
            const date = new Date();
            const filenameDate = `${String(date.getDate()).padStart(2,'0')}${String(date.getMonth()+1).padStart(2,'0')}${date.getFullYear()}`;
            XLSX.writeFile(wb, `${filenameDate}InformeRetorno.xlsx`);
        });
    }

    return (
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Diagnostico retorno"
                idCabezaFamilia="1"
                url="/consultas/verdiagnosticos"
                nombreurl="Diagnosticos"
                nombreform="Retorno"
                />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='card-header' style={{display: 'flex', justifyContent: 'flex-end', textAlign: 'right',}}> 
                                <ButtonsMenu data={filteredData} titulo={'Informe ayudas'} exportarCSV={() => {exportarCSV(watch('FechaInicial').toLocaleDateString('en-CA'), watch('FechaFinal').toLocaleDateString('en-CA'))}} exportaExcel={exportaExcel}/>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Container>
                                        <ButtonGroup aria-label="Basic example">
                                            <label htmlFor="FechaInicial">
                                                <Controller
                                                    control={control}
                                                    name="FechaInicial"
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                            <DatePicker
                                                            id="FechaInicial"
                                                            placeholderText="fecha"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value}
                                                            maxDate={watch('FechaFinal') || fecha}
                                                            customInput={<CustomInput maxDate={watch('FechaFinal') || fecha}/>}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            />
                                                        </div>
                                                    )}
                                                /></label>
                                                {errors.FechaInicial && <p style={{color: 'red'}}>Fecha inicial</p>}
                                            
                                            <label htmlFor="FechaFinal">
                                                <Controller
                                                    control={control}
                                                    name="FechaFinal"
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                            <DatePicker
                                                            id="FechaFinal"
                                                            placeholderText="fecha"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value}
                                                            // FechaFinal cannot be earlier than FechaInicial and not after today
                                                            minDate={watch('FechaInicial') || undefined}
                                                            maxDate={fecha}
                                                            customInput={<CustomInput minDate={watch('FechaInicial') || undefined} maxDate={fecha} />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            />
                                                        </div>
                                                    )}
                                                />{errors.FechaFinal && <p style={{color: 'red'}}>Fecha final</p>}
                                            </label>                                                
                                            <button
                                                type="submit"
                                                className="img-square elevation-1"
                                                style={{
                                                    fontSize: '0.7rem',
                                                    padding: '2px 12px',
                                                    height: 38,
                                                    minWidth: '80px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #6daff1ff',
                                                    borderRadius: 4,
                                                    background: '#abbdcfff',
                                                    display: 'inline-flex',
                                                    alignItems: 'center'
                                                }}
                                                data-tooltip-id='tooltiparriba'
                                                data-tooltip-content="Consultar"
                                            >
                                                <FaSearch /> Buscar
                                            </button>
                                        </ButtonGroup>
                                    </Container>
                                </form>
                            </div>
                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            {columns.map((col, idx) => (
                                                <th key={idx}>{col.name}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {datosRetorno.length === 0 ? (
                                            <tr>
                                                <td colSpan={columns.length} className="text-center">
                                                    No hay datos para mostrar
                                                </td>
                                            </tr>
                                        ) : (
                                            datosRetorno.map((row, rIdx) => (
                                                <tr key={rIdx}>
                                                    {columns.map((col, cIdx) => {
                                                        // prefer cell renderer, fallback to selector function or string key
                                                        if (col.cell) return <td key={cIdx}>{col.cell(row)}</td>;
                                                        if (typeof col.selector === 'function') return <td key={cIdx}>{col.selector(row)}</td>;
                                                        return <td key={cIdx}>{row[col.selector]}</td>;
                                                    })}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}